import axios from 'axios';
import { rawreq,req } from './axiosFun';

/*
*  订单管理
* */

// 查询发卡列表
export const querySendCardList = (params) => { return req("post", "/api/order/querySendCardList", params) };
// 查询购卡列表
export const queryBuyCardList = (params) => { return req("post", "/api/order/queryBuyCardList", params) };

// 统计分析 查询地区报表数据
export const queryAreaTreeReport = (params) => { return rawreq("post", "/api/report/queryAreaTreeReport", params) };

// 统计分析 查询年龄报表数据
export const queryAgeReport = (params) => { return rawreq("post", "/api/report/queryAgeReport", params) };

// 统计分析 查询营销渠道报表数据
export const queryMarketingChannelReport = (params) => { return rawreq("post", "/api/report/queryMarketingChannelReport", params) };


// 查询充值列表
export const queryOrgRecharge = (params) => { return req("post", "/api/org/queryOrgRecharge", params) };
// 查询剩余练习卡数量
export const queryOrgLxkNum = (params) => { return req("post", "/api/org/queryOrgLxkNum", params) };
// 机构充值 卡数量
export const rechargeLxk = (params) => { return req("post", "/api/org/rechargeLxk", params) };
// 机构充值 获取单价
export const queryPrice = (params) => { return req("post", "/api/org/queryPrice", params) };
// 删除zt不为2的 充值列表
export const deleteRechargeById = (id) => { return req("get", "/api/org/deleteRechargeById?id=" + id, '') };


/*
*  提现记录
* */
// 查询提现历史记录列表
export const queryTxList = (params) => { return req("post", "/api/tx/queryTxList", params) };
// 获取提现信息---展示在最上方
export const queryTxInfo = (params) => { return req("post", "/api/tx/queryTxInfo", params) };
// 提现
export const saveTx = (params) => { return req("post", "/api/tx/saveTx", params) };
// 删除  不能删除 zt 字段为1的
export const deleteTxById = (params) => { return req("get", "/api/tx/deleteTxById?id=" + params, '') };


/*
*  礼品卡管理
* */
// 查询礼品卡列表
export const queryGiftCardList = (params) => { return req("post", "/api/giftCard/queryGiftCardList", params) };
// 批量生成礼品卡
export const generateGiftCard = (params) => { return req("get", "/api/giftCard/generateGiftCard?num=" + params, '') };




// WEBPACK FOOTER //
// ./src/api/order.js